import crossDomainTracking from './crossDomainTracking';
import googleAnalytics4 from './googleAnalytics4';
import AnalyticsTracking from './AnalyticsTracking';
import log from './log';
import sendGAClientId from './sendGAClientId';

// Code for sending chats or leads data over to multiple trackings
const sendChatAndLeadAnalytics = (ApexChatStartData, isChat, visitorsGoogleClientId) => {
    const companytrackings = ApexChatStartData.companyTrackingTypes;
    if (companytrackings && companytrackings.length > 0) {
        try {
            const gaCode = ApexChatStartData.googleUniversalCode;
            const fbCode = ApexChatStartData.facebookPixelCode;
            const customAnalyticsLeadCode = ApexChatStartData.leadCodeForCustomAnalytics;
            const customAnalyticsChatCode = ApexChatStartData.chatCodeForCustomAnalytics;
            const domain = ApexChatStartData.googleAnalyticsDomain;

            for (let i = 0; i < companytrackings.length; i++) {
                // conditions to check
                const checkGoogleUniversal =
                    AnalyticsTracking.GoogleUniversal == companytrackings[i].trackingType &&
                    ApexChatStartData.googleAnalyticsAccount &&
                    gaCode;
                const checkGoogleAnalyticsWithClientId =
                    AnalyticsTracking.GoogleAnalyticsClientId == companytrackings[i].trackingType &&
                    ApexChatStartData.googleAnalyticsAccount;
                const checkFacebook =
                    AnalyticsTracking.FacebookPixel == companytrackings[i].trackingType &&
                    ApexChatStartData.facebookPixelAccount &&
                    fbCode;
                const checkCustom =
                    AnalyticsTracking.Custom == companytrackings[i].trackingType &&
                    (customAnalyticsLeadCode || customAnalyticsChatCode);
                const checkCrossDomainTracking =
                    AnalyticsTracking.GoogleAnalyticsCrossDomainTracking ==
                    companytrackings[i].trackingType && ApexChatStartData.googleAnalyticsDomain;
                const checkGoogleAnalytics4 =
                    AnalyticsTracking.GoogleAnalytics4 == companytrackings[i].trackingType &&
                    ApexChatStartData.googleAnalyticsMeasurementId;
                if (checkGoogleUniversal || checkGoogleAnalyticsWithClientId) {
                    if (checkGoogleAnalyticsWithClientId) {
                        // New and improved procedure for sending chats to GA by clientId
                        sendGAClientId(
                            visitorsGoogleClientId,
                            gat,
                            ApexChatStartData.googleAnalyticsAccount,
                            isChat ? 'LiveChat' : 'LiveChatLead',
                            isChat ? 'LiveChatStarted' : 'LiveChatLeadStarted',
                            isChat ? 'LiveChatConverted' : 'LiveChatLeadConverted'
                        );
                    } else {
                        eval(gaCode);

                        import(/* webpackChunkName: "GoogleUniversalTracker" */ './GoogleUniversalTracker').then(module => {
                            const GoogleUniversalTracker = module.default;
                            // sending over chats source, medium etc to google universal; if source is null than landing referrer should be sent as source else none
                            GoogleUniversalTracker(
                                ApexChatStartData.googleAnalyticsAccount,
                                isChat ? '/chats' : '/chatToLead',
                                isChat ? 'Chats' : 'ChatsToLeads',
                                isChat ? 'chatStarted' : 'converted',
                                ApexChatStartData.googleAnalyticsCampaignSource
                                    ? ApexChatStartData.googleAnalyticsCampaignSource
                                    : ApexChatStartData.landingReferrer
                                        ? ApexChatStartData.landingReferrer
                                        : 'direct',
                                ApexChatStartData.googleAnalyticsCampaignMedium
                                    ? ApexChatStartData.googleAnalyticsCampaignMedium
                                    : 'none',
                                ApexChatStartData.googleAnalyticsCampaignName
                                    ? ApexChatStartData.googleAnalyticsCampaignName
                                    : 'none',
                                ApexChatStartData.googleAnalyticsCampaignContent
                                    ? ApexChatStartData.googleAnalyticsCampaignContent
                                    : 'none'
                            );
                        })


                    }
                } else if (checkCrossDomainTracking) {
                    crossDomainTracking(
                        ApexChatStartData.googleAnalyticsDomain,
                        ApexChatStartData.googleAnalyticsAccount,
                        isChat
                    );
                } else if (checkFacebook) {
                    eval(fbCode);
                    // sending over chats/Leads to facebook pixel
                    ApexChatStartData.facebookFunction(
                        ApexChatStartData.facebookPixelAccount,
                        isChat ? 'Chat' : 'Lead'
                    );
                } else if (checkCustom) {
                    if (isChat) {
                        // sending over chats to user defined analytic engine
                        const sendChatInfoToCustomAnalyticsEngine = new Function(
                            customAnalyticsChatCode
                        );
                        sendChatInfoToCustomAnalyticsEngine();
                    } else {
                        // sending over leads to user defined analytic engine
                        const sendLeadInfoToCustomAnalyticsEngine = new Function(
                            customAnalyticsLeadCode
                        );
                        sendLeadInfoToCustomAnalyticsEngine();
                    }
                } else if (checkGoogleAnalytics4) {
                    googleAnalytics4(ApexChatStartData.googleAnalyticsMeasurementId, isChat);
                }
            }
        } catch (e) {
            log(e);
        }
    }
};
export default sendChatAndLeadAnalytics;
